import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TranslatedTextField from "./TranslatedTextField";
import MediaUploadField from "./MediaUploadField";
import { ContentBlockType } from "../constants";
import { LessonFormData, emptyLocalizedText } from "../types";
import { useActiveLocale } from "../ActiveLocaleContext";

type Props = {
  partIndex: number;
  blockIndex: number;
  type: ContentBlockType;
};

const ContentBlockField: React.VFC<Props> = ({ partIndex, blockIndex, type }) => {
  const { control, register, setValue } = useFormContext<LessonFormData>();
  const { activeLocale } = useActiveLocale();
  const typeName = `parts.${partIndex}.content.${blockIndex}.type` as const;

  // Register the type field and keep it in sync with the prop.
  // A hidden Controller with an empty render doesn't reliably persist in RHF v6.
  useEffect(() => {
    register({ name: typeName });
    setValue(typeName, type);
  }, [register, setValue, typeName, type]);

  return (
    <Controller
      control={control}
      name={`parts.${partIndex}.content.${blockIndex}.content` as const}
      render={({ onChange, value }) => {
        if (type === "image") {
          return <MediaUploadField label="Image" value={value ?? emptyLocalizedText()} onChange={onChange} />;
        }
        return (
          <TranslatedTextField
            label={type === "heading" ? "Heading" : "Paragraph"}
            value={value ?? emptyLocalizedText()}
            onChange={onChange}
            activeLocale={activeLocale}
            autoTranslate
            multiline={type === "paragraph"}
            rows={type === "paragraph" ? 4 : 1}
          />
        );
      }}
    />
  );
};

export default ContentBlockField;
